import { Component, Input, ViewEncapsulation } from '@angular/core';
import { MatDividerModule } from '@angular/material/divider';
import { TranslateModule } from '@ngx-translate/core';
import { MatExpansionModule } from '@angular/material/expansion';
import { NgIf, NgFor } from '@angular/common';
import { MatIconModule } from '@angular/material/icon';
import { MatTooltipModule } from '@angular/material/tooltip';

import { UNDERSCORE } from '../../../../shared/utils/constant';
import { pageTransitions } from '../../../../shared/animations/page-transitions';
import { CoilSegment } from '../../../models/coil-segment';
import { AqdbQualityDataService } from '../../../services/aqdb-quality-data.service';
import { AqdbConditions, AqdbMeMoFlag } from '../../../models/aqdb-constants';
import { NumberPipe } from '../../../../shared/pipes/number.pipe';

@Component({
	selector: 'copo-surface-cleanliness',
	templateUrl: './surface-cleanliness.component.html',
	styleUrl: '../aqdb-batch-card.component.css',
	animations: pageTransitions,
	encapsulation: ViewEncapsulation.Emulated,
	imports: [
		NgIf,
		MatExpansionModule,
		TranslateModule,
		MatDividerModule,
		NgFor,
		MatIconModule,
		MatTooltipModule,
		NumberPipe
	]
})
export class SurfaceCleanlinessComponent {
	@Input() isValidServiceAvailable = false;
	@Input() segment?: CoilSegment;
	readonly UNDERSCORE = UNDERSCORE;

	constructor(
		private readonly aqdbQualityDataService: AqdbQualityDataService,
	) {}

	isDisplayedDataForCoatingSurface(conditions: AqdbConditions) {
		return this.aqdbQualityDataService.isDisplayedDataForCoatingSurface(this.isValidServiceAvailable, conditions);
	}

	isTransmittedOnCertificateData(conditions: AqdbConditions) {
		return this.aqdbQualityDataService.isTransmittedOnCertificateData(this.isValidServiceAvailable, conditions);
	}

	isMeasuredData(conditions: AqdbConditions, meMoFlag: AqdbMeMoFlag) {
		return this.aqdbQualityDataService.isMeasuredData(this.isValidServiceAvailable, conditions, meMoFlag);
	}

	isModelledData(conditions: AqdbConditions, meMoFlag: AqdbMeMoFlag) {
		return this.aqdbQualityDataService.isModelledData(this.isValidServiceAvailable, conditions, meMoFlag);
	}
}
